import React from 'react'
import { Grid, Form, Item, Button } from 'semantic-ui-react'

export default class ChecklistTooltip extends React.Component {
  onChange(val) {
    this.setState({ internalNotes: val })
  }

  render() {
    const marginTop = { marginTop: "15px" }
    const { name, checked, internalNotes, handleSubmit, handleCancel } = this.props
    return (
      <div>
        <Grid style={{width: "480px"}}>
          <Grid.Column width='4'>
            <Item><strong>{name}:</strong></Item>
          </Grid.Column>
          <Grid.Column width='12'>
            <Item>{checked === true ? 'True' : 'False'}</Item>
          </Grid.Column>
        </Grid>

        <Form onSubmit={handleSubmit}>
          <div style={marginTop}>
            <textarea
              value={internalNotes}
              rows="10"
              style={{width: "460px"}}
              onChange={(e) => this.props.handleChange(e.target.value)}
            >
            </textarea>
          </div>
          <div style={marginTop}>
            <Button primary type="submit" value="Filter">Submit</Button>
            <Button secondary type="button" value="Filter" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
          <div style={{marginTop: "10px"}}>
            <small>* Changes to "{name}" will not be saved until submitted</small>
          </div>
        </Form>
      </div>
    )
  }
}
